// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 引入storre
import store from './store'
// 引入axios
import axios from './axios'
// 引入cookies
import VueCookies from 'vue-cookies'
// 对es6的兼容 webpack.base.conf.js
import 'babel-polyfill'
// 引入全局变量
import Global from './components/public-component/global'
// 引入js
import ElementUI from 'element-ui'
// 引入css
import 'element-ui/lib/theme-chalk/index.css'
// 引入自定义主题
import '../theme/index.css'
// 引入全局过滤
import Filters from './assets/js/filter'
import Home from './components/home'
// 设置title
import VueWechatTitle from 'vue-wechat-title'

// vue-axios携带cookie值
// axios.defaults.withCredentials = true;

Vue.use(ElementUI);
Vue.use(VueWechatTitle);
Vue.use(VueCookies);
Vue.config.productionTip = false;
Vue.prototype.Global = Global;
Vue.prototype.Filters = Filters;
Vue.prototype.Home = Home;
for (let key in Filters) {
  Vue.filter(key, Filters[key]);
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  axios,
  router,
  store, // 使用store
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js